"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalGameService = void 0;
const api_1 = require("./api");
const PATH_V1 = '/digital-game/api/v1';
class DigitalGameService {
    static async fetchDigitalGame(key) {
        const response = await api_1.API.get({
            url: `${PATH_V1}/digital-game/${key}`
        });
        return response;
    }
    static async playForPoints(key) {
        return api_1.API.post({
            url: `${PATH_V1}/points/${key}`,
            body: {}
        });
    }
    static async playForFun(key) {
        return api_1.API.post({
            url: `${PATH_V1}/fun/${key}`,
            body: {}
        });
    }
}
exports.DigitalGameService = DigitalGameService;
//# sourceMappingURL=digital-game-service.js.map